export default "__VITE_ASSET__BQb_7dhF__"